export default __webpack_public_path__ + "static/model_3-34825253106dff206cdbf4dd8388eaf1.webp";